import React from 'react';
import { ReactComponent as AssignationStatusUnassignedIcon } from 'assets/xpo_icons/assignation-status.svg';
import { SETTINGS, STATES } from 'refactored/features/emergencies/constants';
import BodyColumn from 'refactored/features/emergencies/ui/columns/body-column';
import { generateColor, getUserInitials } from '../utils/user';
import AvatarWrapper from 'refactored/features/emergencies/ui/avatar/avatar-wrapper';
import AvatarsContainer from 'refactored/features/emergencies/ui/avatar/avatars-container';
import AvatarLetters from 'refactored/features/emergencies/ui/avatar/avatar-letters';
import { Tooltip } from '@ontruck/orc';
import { AgentAssignedTooltip } from '../tooltips';

export const OwnerAgentColumn = ({ ticket, reset }) => {
  const hasAgent = !!ticket?.assigned_to?.id;
  const disabledStates = [
    STATES.CANCELLED,
    STATES.DONE,
    STATES.OUT_OF_SCOPE,
    STATES.ACCEPTED,
  ];
  const assignDisabled = disabledStates.includes(ticket.synthetic_state);

  return (
    <BodyColumn width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.OWNER}>
      <AvatarsContainer>
        <Tooltip
          component={
            <AgentAssignedTooltip ticket={ticket} disabled={assignDisabled} />
          }
          position="left"
          skin="dark"
        >
          <AvatarWrapper active={false}>
            {hasAgent ? (
              <AvatarLetters
                background={generateColor(ticket?.assigned_to?.username)}
              >
                {getUserInitials(ticket?.assigned_to)}
              </AvatarLetters>
            ) : (
              <AssignationStatusUnassignedIcon />
            )}
          </AvatarWrapper>
        </Tooltip>
      </AvatarsContainer>
    </BodyColumn>
  );
};
